import RightSection from "./RightSection";

export default RightSection;
